import type { AccessToken } from './accessToken.types'

const AUTH_TOKEN_CACHE = 'authToken'

export function authTokenGet(): AccessToken | undefined {
  if (!window) return
  const authToken = localStorage.getItem(AUTH_TOKEN_CACHE)
  if (!authToken) return
  return JSON.parse(authToken)
}

export function authTokenSet(authToken: AccessToken) {
  if (!window) return
  localStorage.setItem(AUTH_TOKEN_CACHE, JSON.stringify(authToken))
}

export function authTokenReset() {
  if (!window) return
  localStorage.removeItem(AUTH_TOKEN_CACHE)
}

export function accessTokenGet(): string | undefined {
  const authToken = authTokenGet()
  return authToken?.accessToken
}

export function refreshTokenGet(): string | undefined {
  const authToken = authTokenGet()
  return authToken?.refreshToken
}

export function authTokenExpiresAtGet(): number | undefined {
  const authToken = authTokenGet()
  return authToken?.expiresAt || Date.now() / 1000 - 1
}

export function authTokenIsExpires(): boolean {
  const expiresAt = authTokenExpiresAtGet() || 0
  const unixSec = Math.ceil(Date.now() / 1000)
  return expiresAt < unixSec
}
